// extracted by mini-css-extract-plugin
export default {"button":"button_button__b3bsL","primary":"button_primary__hEsja","secondary":"button_secondary__fBqCN","simple":"button_simple__FpHHd"};